/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useGlobalTheme } from '@atlaskit/theme/components';
import { fontFamily as getFontFamily, gridSize as getGridSize } from '@atlaskit/theme/constants';
import { h200 } from '@atlaskit/theme/typography';
var fontFamily = getFontFamily();
var gridSize = getGridSize();
var labelStyles = css({
  display: 'inline-block',
  marginTop: 0,
  marginBottom: gridSize / 2,
  fontFamily: fontFamily
}); // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage

var lightH200Styles = css(h200({
  theme: {
    mode: 'light'
  }
})); // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage

var darkH200Styles = css(h200({
  theme: {
    mode: 'dark'
  }
}));
/**
 * __Label__
 *
 * A label represents a caption for an item in a user interface.
 *
 * It's recommended that a label has a `4px` spacing above its associated
 * control element.
 */

var Label = function Label(_ref) {
  var children = _ref.children,
      htmlFor = _ref.htmlFor,
      id = _ref.id;

  var _useGlobalTheme = useGlobalTheme(),
      mode = _useGlobalTheme.mode;

  return jsx("label", {
    css: [mode === 'light' ? lightH200Styles : darkH200Styles, labelStyles],
    id: id,
    htmlFor: htmlFor
  }, children);
};

export default Label;